"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sidebar = void 0;

var react_1 = __importDefault(require("react"));

var nav_mobile_1 = require("./nav-mobile");

var nav_static_1 = require("./nav-static");

var Sidebar = function Sidebar(_a) {
  // const style = `container mx-auto z-10 ${
  //   theme
  //     ? `${theme.bgColor} ${theme.textColor} ${theme.shadowColor}`
  //     : "bg-gray-100 text-gray-900"
  // }`;
  var children = _a.children,
      backgroundImage = _a.backgroundImage; // console.log("style: ", style);

  if (backgroundImage) {
    document.body.style.backgroundImage = "url(" + backgroundImage + ")";
    document.body.style.backgroundAttachment = "fixed";
  }

  return react_1["default"].createElement("div", {
    className: "h-screen flex overflow-hidden bg-white"
  }, react_1["default"].createElement(nav_mobile_1.NavMobile, null), react_1["default"].createElement(nav_static_1.NavStatic, null), react_1["default"].createElement("div", {
    className: "flex flex-col w-0 flex-1 overflow-hidden"
  }, react_1["default"].createElement("div", {
    className: "md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3"
  }, react_1["default"].createElement("button", {
    className: "-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150",
    "aria-label": "Open sidebar"
  }, react_1["default"].createElement("svg", {
    className: "h-6 w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, react_1["default"].createElement("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M4 6h16M4 12h16M4 18h16"
  })))), react_1["default"].createElement("main", {
    className: "flex-1 relative z-0 overflow-y-auto pt-2 pb-6 focus:outline-none md:py-6",
    tabIndex: 0
  }, react_1["default"].createElement("div", {
    className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8"
  }, react_1["default"].createElement("h1", {
    className: "text-2xl font-semibold text-gray-900"
  }, "Dashboard")), react_1["default"].createElement("div", {
    className: "max-w-7xl mx-auto px-4 sm:px-6 md:px-8"
  }, react_1["default"].createElement("div", {
    className: "py-4"
  }, react_1["default"].createElement("div", {
    className: "border-4 border-dashed border-gray-200 rounded-lg h-96"
  }, children))))));
};

exports.Sidebar = Sidebar;